module.exports = __webpack_public_path__ + "static/img/ArtPlus&TanuwaImage.f9ba052.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ArtPlus&TanuwaImage.jpeg
// module id = rCBT
// module chunks = 1